import { Options } from './../../../core/interfaces/order.interface';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';
import { TSortFilter } from '@types';

@Component({
  selector: 'unicon-sort-filters',
  templateUrl: './sort-filters.component.html',
})
export class SortFiltersComponent {
  @Input() sortStyle: TSortFilter = 'newest-first';
  @Input() selectedColumn!: Options;
  @Input() title: string = 'Ordenar por';
  @Input() typeTab!: string;
  @Input() items: TSortFilter[] = [
    'newest-first',
    'highest-quantity-first',
    'oldest-first',
  ];
  @Input() description: Record<TSortFilter, string> = {
    ['newest-first']: 'Más recientes',
    ['highest-quantity-first']: 'Volumen del pedido',
    ['oldest-first']: 'Antigüedad',
  };
  @Output() sort: EventEmitter<MatRadioChange> =
    new EventEmitter<MatRadioChange>();
}
